import { TapelineDTO } from '@mutations'
import { getRequest } from '../utils'

export interface FilterViewData {
  hiddenElementIds: string[] | null
  activeStorey: string | null
  visibleStoreys: string[] | null
  byTypeStoreyVisibility: Record<ElementTypes, string[]> | null
  byTypeVisibility: Record<ElementTypes, boolean> | null
}

export interface FilterViewModel extends FilterViewData {
  id: string
  name: string
  isDefault: boolean
  isDeletable: boolean
  isModifiable: boolean
  tapelines: TapelineDTO[]
}

export interface FilterViewsData {
  filterViews: FilterViewModel[]
  activeFilterViewId: string
}

export const getFilterViews: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['getFilterViews', projectGuid],
  request: async (projectGuid: string): Promise<FilterViewsData> => {
    const { data } = await getRequest<FilterViewsData>({
      url: `/projects/${projectGuid}/filter-views`,
    })

    if (!data) {
      throw new Error('Empty filter views response')
    }
    return data
  },
}
